import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib';
import { Badge } from '../../ui';

const statusColors = {
  SENT: 'bg-gray-100 text-gray-700',
  DELIVERED: 'bg-green-100 text-green-700',
  BOUNCED: 'bg-red-100 text-red-700',
  COMPLAINED: 'bg-orange-100 text-orange-700',
  OPENED: 'bg-green-100 text-green-700',
  REJECTED: 'bg-red-100 text-red-700',
  NEGLECTED: 'bg-red-100 text-red-700',
};

interface NotificationsStatusBadgeProps {
  readonly status: keyof typeof statusColors;
}

export function NotificationsStatusBadge({ status }: NotificationsStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      variant="outline"
      className={cn(statusColors[status], 'font-bold hover:bg-none border-none')}
    >
      {t(`notifications.statuses.${status}`)}
    </Badge>
  );
}
